export const MODAL_TITLE_ADD_RATING = 'Оцените нас'
export const MODAL_TITLE_PROBLEM_NOT_SOLVED = 'Проблему не решили'
